module.exports = __webpack_public_path__ + "img/charactor_00.eedc5a39.png";